import api from "./axios";
import type { User } from "@/types";

export type InviteableUser = Pick<User, "id" | "email" | "displayName">;

export const search = (query: string) =>
  api
    .get<InviteableUser[]>("/users/search", { params: { q: query } })
    .then((r) => r.data);

export const getMe = (id: string) =>
  api.get<InviteableUser>(`/users/${id}`).then((r) => r.data);
